module.exports = __webpack_public_path__ + "static/img/applyBanner.81da8459.jpg";